import axios from "axios";
import moment from "moment-timezone";

export const endpoint = "/api/register";

export const register = (user) => {
  let form = new FormData();
  form.append("token", user.token);
  if (user.business_name && user.isProvider && !user.isProviderAdmin) {
    form.append("business_name", user.business_name);
  }
  form.append("user[two_factor_auth]", user.two_factor_auth ? "1" : "0");
  form.append("user[email]", user.email);
  form.append("user[password]", user.password);
  form.append("user[password_confirmation]", user.duplicatePassword);
  form.append("user[username]", user.username);
  form.append("user[timezone]", moment.tz.guess());
  form.append("user[first_name]", user.first_name);
  form.append("user[last_name]", user.last_name);
  form.append("user[terms_accepted]", user.tosAccepted ? "1" : "0");
  return axios.post(`${endpoint}`, form);
};

export const verifyEmail = (token) => {
  return axios.get(`${endpoint}/email-verification/${token}`);
};

export const resendVerificationEmail = (username) => {
  let form = new FormData();
  form.append("username", username);
  return axios.post(`${endpoint}/resend-verification-email`, form);
};

export const getRegisterData = (token) => {
  return axios.get(`${endpoint}/data/${token}`);
};
